import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material';
import { lightTheme } from '@softland/design-system';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Auth from 'modules/auth/Auth';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import Error from './modules/auth/login/component/Error';

import './index.css';

const queryLogin = new QueryClient();

// Figma button color (adjust if you have an exact hex from design)
const btnPrimaryColor = '#1F4B3F';
const btnPrimaryColorHover = '#173A31';

const theme = createTheme(lightTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: btnPrimaryColor,
          '&:hover': { backgroundColor: btnPrimaryColorHover },
        },
      },
    },
    MuiLoadingButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: btnPrimaryColor,
          '&:hover': { backgroundColor: btnPrimaryColorHover },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <QueryClientProvider client={queryLogin}>
          <Routes>
            <Route path="*" element={<Auth />}></Route>
            <Route path="/error" element={<Error />}></Route>
          </Routes>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
